import { HttpErrorResponse, type HttpEvent, HttpHandler, type HttpInterceptor, HttpRequest } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { catchError, from, Observable, switchMap, throwError, of } from "rxjs";
import { ElevatedMfaService } from "../services/elevated-mfa.service";
import { CognitoService } from "../services/cognito-service";
import { Router } from '@angular/router';

@Injectable()
export class ElevatedMfaInterceptor implements HttpInterceptor {

  constructor(
    private elevatedMfaService: ElevatedMfaService,
    private cognitoService: CognitoService,
    private router: Router
  ) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(req).pipe(
      catchError((error: HttpErrorResponse) => {

        if (error.status !== 401 || !this.cognitoService.hasActiveSession()) {
          return throwError(() => error);
        }

        return this.elevatedMfaService
          .openMfaDialog()
          .pipe(
            switchMap(result => {

              if (result?.action !== 'verified') {
                // Redirect to dashboard if MFA was not completed successfully
                this.router.navigate(['/dashboard']);
                return of();
              }

              return next.handle(req);
            })
          );
      })
    );
  }
}